/**
 * 생성된 선지/답안을 폼에 쓴다. plain 필드에 마크업이 새지 않도록
 * 채팅 어댑터(adaptAiGeneratedQuizzesToBuildForm)와 같은 정규화를 거친다.
 * 필드 경로는 QUIZ_SLOT_SCHEMA 의 `path` 가 정한다.
 */
import { type UseFormSetValue } from 'react-hook-form';

import { prepareTiptapHTML } from '@/shared/features/rich-text';
import { extractBareText } from '@/shared/utils/extractBareText';

import { type BuildSchemaInputType } from '../../../form/schema';
import { type BuildQuizListItem } from '../../../form/schema/BuildQuizListSchema';

import { slotSchemaOf } from './questionCardAiSlotSchema';

type SetValue = UseFormSetValue<BuildSchemaInputType>;

const DIRTY = { shouldDirty: true } as const;

export const writeOptionFills = (
  setValue: SetValue,
  quiz: BuildQuizListItem,
  quizIndex: number,
  filled: { index: number; text: string }[],
): void => {
  const schema = slotSchemaOf(quiz.type);
  if (!schema) return;
  // index 는 applyOptionFill 이 슬롯 id 로 찾아 준 **적용 시점** 자리다.
  for (const { index, text } of filled) {
    const rich = prepareTiptapHTML(text);
    const path = schema.path(quizIndex, index);
    setValue(path.text, extractBareText(rich), DIRTY);
    if (path.richText) setValue(path.richText, rich, DIRTY);
  }
};

/**
 * AI 가 지목한 정답 자리를 찍는다. 교사가 이미 고른 정답은 resolveAnswerSlotToMark 가
 * null 을 돌려주므로 여기까지 오지 않는다.
 */
export const writeAnswerMarks = (
  setValue: SetValue,
  quiz: BuildQuizListItem,
  quizIndex: number,
  decision: { mark: number[]; clear: number[] },
): void => {
  const schema = slotSchemaOf(quiz.type);
  if (!schema) return;
  const marks = [
    ...decision.clear.map(index => [index, false] as const),
    ...decision.mark.map(index => [index, true] as const),
  ];
  for (const [index, isAnswer] of marks) {
    const path = schema.path(quizIndex, index).isAnswer;
    if (path) setValue(path, isAnswer, DIRTY);
  }
};
